import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const o=t("bitcoin",i`
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            static
        >
            <g clip-path="url(#clip0_4874_292)">
                <path
                    d="M23.3587 15.2268C21.7749 21.5793 15.3407 25.4453 8.98739 23.8613C2.63669 22.2775 -1.22943 15.8431 0.355213 9.49082C1.93821 3.13754 8.37225 -0.728921 14.7238 0.854839C21.0768 2.43873 24.9426 8.87391 23.3586 15.2268L23.3587 15.2268Z"
                    fill="url(#paint0_linear_4874_292)"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.2898 10.7897C17.5287 9.19299 16.3129 8.33457 14.6503 7.76195L15.1895 5.59895L13.8728 5.27091L13.3477 7.37684C13.0016 7.29055 12.6461 7.20913 12.2928 7.12859L12.8216 5.00873L11.5055 4.68066L10.9659 6.84295C10.6793 6.77766 10.398 6.71324 10.1252 6.64532L10.1266 6.63857L8.3106 6.18521L7.96041 7.59147C7.96041 7.59147 8.93733 7.81535 8.91676 7.82914C9.45017 7.96222 9.5464 8.31521 9.5304 8.59485L8.91605 11.0589C8.95275 11.0683 9.00041 11.0818 9.05297 11.1028C9.00906 11.0919 8.9621 11.0799 8.91387 11.0683L8.05271 14.5202C7.98738 14.6821 7.82202 14.9251 7.44919 14.833C7.46222 14.852 6.49207 14.5941 6.49207 14.5941L5.83838 16.1012L7.55186 16.5282C7.87078 16.608 8.18317 16.6917 8.49067 16.7705L7.94571 18.9583L9.26102 19.2863L9.80069 17.1218C10.16 17.2194 10.5088 17.3093 10.8501 17.3941L10.3123 19.5485L11.6291 19.8765L12.1741 17.693C14.4195 18.1179 16.1079 17.9465 16.8185 15.9158C17.3912 14.2809 16.7901 13.3378 15.6086 12.7228C16.4689 12.5245 17.117 11.9586 17.2898 10.7897L17.2898 10.7897ZM14.2825 15.0076C13.8756 16.6426 11.1223 15.7588 10.2297 15.5371L10.9528 12.6388C11.8454 12.8615 14.7077 13.3025 14.2825 15.0076V15.0076ZM14.6883 10.7669C14.3171 12.2541 12.0256 11.4985 11.2822 11.3132L11.9378 8.68457C12.6811 8.86972 15.0749 9.21552 14.6883 10.7669Z"
                    fill="white"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_4874_292"
                    x1="6.2771"
                    y1="39.8177"
                    x2="6.2771"
                    y2="39.817"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#F9AA4B" />
                    <stop offset="1" stop-color="#F7931A" />
                </linearGradient>
                <clipPath id="clip0_4874_292">
                    <rect y="0.5" width="24" height="24" rx="4" fill="white" />
                </clipPath>
            </defs>
        </svg>
    `),p=t("bitcoin_cash",i`
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            static
            fill="none"
        >
            <g clip-path="url(#clip0_8800_9128)">
                <path
                    d="M23.5838 14.7268C22 21.0793 15.5658 24.9453 9.21249 23.3613C2.86179 21.7775 -1.00433 15.3431 0.580311 8.99082C2.16331 2.63754 8.59735 -1.22892 14.9489 0.354839C21.3019 1.93873 25.1677 8.37391 23.5837 14.7268L23.5838 14.7268Z"
                    fill="#0AC18E"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.0054 7.63418C15.414 6.13197 13.9318 5.99646 12.2057 6.33186L11.5911 4.18904L10.2868 4.56331L10.8851 6.64962C10.5422 6.74796 10.1936 6.85521 9.84733 6.9621L9.24533 4.86187L7.94159 5.23576L8.55537 7.37819C8.27457 7.46491 7.99874 7.54978 7.72847 7.62739L7.72633 7.62084L5.92697 8.1362L6.32683 9.52915C6.32683 9.52915 7.28481 9.23457 7.27389 9.25681C7.80238 9.10535 8.06221 9.36294 8.18817 9.61311L8.88815 12.0542C8.92463 12.044 8.97265 12.0319 9.02866 12.0237C8.9852 12.0363 8.93852 12.0494 8.89096 12.0634L9.87111 15.4834C9.89552 15.6564 9.87379 15.9494 9.50485 16.0561C9.52566 16.0661 8.55652 16.3278 8.55652 16.3278L8.74394 17.9598L10.4414 17.4729C10.7575 17.3825 11.0698 17.2988 11.3756 17.2133L11.9975 19.3804L13.3006 19.0069L12.6857 16.8626C13.0457 16.7674 13.3927 16.6709 13.7307 16.5737L14.3421 18.7083L15.6465 18.334L15.0267 16.1705C17.1838 15.4158 18.5603 14.4232 18.1604 12.3092C17.8388 10.607 16.8467 10.0908 15.516 10.1489C16.1619 9.54699 16.4402 8.73288 16.0055 7.6342L16.0054 7.63418ZM15.5099 12.7907C15.9751 14.4101 13.1487 15.0213 12.2649 15.2756L11.442 12.404C12.3263 12.1506 15.0256 11.1014 15.5099 12.7907L15.5099 12.7907ZM13.7409 8.91474C14.163 10.3883 11.8007 10.8798 11.0643 11.091L10.3178 8.48664C11.054 8.27539 13.3001 7.37792 13.7409 8.91474Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_8800_9128">
                    <rect
                        x="0.225098"
                        width="24"
                        height="24"
                        rx="4"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    `);export{o as Bitcoin,p as BitcoinCash};
